import {useMemo} from "react";
import {DatePicker} from "@material-ui/pickers";
import {format} from "date-fns";
import {useTranslation} from "react-i18next";

import {KTSVG} from "../../../../../../../_metronic/helpers";

const toDateKey = (date) => {
  if (!date || Number.isNaN(date.getTime?.())) {
    return null;
  }

  return format(date, "yyyy-LL-dd");
};

const AvailableDatePicker = ({
  availableDates = [],
  buttonClassName = "fw-bold text-gray-800 text-hover-primary fs-7 mt-5 mb-5",
  date,
  label = "",
  openedDatePicker,
  placeholder,
  setDate,
  setOpenedDatePicker,
}) => {
  const {t} = useTranslation();
  const availableDateSet = useMemo(() => new Set(availableDates || []), [availableDates]);
  const hasAvailableDates = availableDateSet.size > 0;
  const displayDate = date ? format(date, "dd/MM/yyyy") : (placeholder || "-");
  const displayText = label ? `${label}: ${displayDate}` : displayDate;
  const isAvailableDate = (value) => availableDateSet.has(toDateKey(value));

  const renderCalendarDay = (day, pickerSelectedDate, dayInCurrentMonth, dayComponent) => {
    const dateKey = toDateKey(day);
    const selectedDateKey = toDateKey(pickerSelectedDate);
    const className = [
      "ndvi-report-calendar-day",
      dayInCurrentMonth ? "" : "is-outside-month",
      availableDateSet.has(dateKey) ? "is-available" : "",
      selectedDateKey === dateKey ? "active" : "",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div className={className}>
        {dayComponent}
      </div>
    );
  };

  return (
    <>
      <DatePicker
        open={hasAvailableDates && openedDatePicker}
        value={date}
        autoOk
        okLabel={null}
        cancelLabel={t("common:actions.cancel")}
        onOpen={() => setOpenedDatePicker(true)}
        onClose={() => setOpenedDatePicker(false)}
        onChange={(nextDate) => {
          if (nextDate && isAvailableDate(nextDate)) {
            setDate(nextDate);
          }

          setOpenedDatePicker(false);
        }}
        renderDay={renderCalendarDay}
        shouldDisableDate={(value) => !isAvailableDate(value)}
        animateYearScrolling
        DialogProps={{
          maxWidth: false,
          PaperProps: {
            className: "ndvi-report-date-picker-dialog",
          },
        }}
        TextFieldComponent={() => null}
      />
      <button
        type="button"
        onClick={() => setOpenedDatePicker(true)}
        disabled={!hasAvailableDates}
        className={`btn btn-link p-0 ${buttonClassName}`.trim()}
      >
        <KTSVG
          path="/media/icons/duotune/general/gen014.svg"
          className="svg-icon svg-icon-2x svg-icon-primary me-5"
        />
        {displayText}
      </button>
    </>
  );
};

export default AvailableDatePicker;
